var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.76,16.25h14.24V4.25H4v13.39l1.76-1.39Zm.69,2l-4.45,3.5V3.25c0-.27.11-.52.29-.71.19-.19.44-.29.71-.29h18c.27,0,.52.11.71.29.19.19.29.44.29.71v14c0,.27-.11.52-.29.71s-.44.29-.71.29H6.45Zm4.55-5h2v2h-2v-2Zm-2.43-5.19c.13-.65.44-1.25.9-1.73.46-.48,1.04-.82,1.69-.98.64-.16,1.32-.14,1.95.07.63.21,1.19.59,1.61,1.1.42.51.69,1.13.77,1.79.08.66-.03,1.33-.31,1.92-.28.6-.73,1.11-1.29,1.46-.56.35-1.21.54-1.87.54h-1v-2h1c.28,0,.56-.08.8-.23.24-.15.43-.37.55-.63.12-.26.17-.54.13-.82-.03-.28-.15-.55-.33-.77-.18-.22-.42-.38-.69-.47-.27-.09-.56-.1-.83-.03-.28.07-.53.21-.72.42-.2.21-.33.46-.39.74l-1.96-.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.30dc41152d55e952a0cd8bdc3c629c39.svg";
export { ForwardRef as ReactComponent };